import {
  TODAY_AND_N_DAYS,
  TODAY_AND_N_WEEKDAYS,
} from '@groove/api/helpers/nonSFDCfields';

import { MergeField } from '../type';

export const isCustomMergeFieldWithDays = (mergeField: MergeField): boolean => {
  return (
    mergeField.name === TODAY_AND_N_DAYS ||
    mergeField.name === TODAY_AND_N_WEEKDAYS
  );
};

export const isAddDaysValid = (
  selectedMergeField: MergeField | null,
  days?: string | number,
): boolean => {
  if (!selectedMergeField) return false;

  return isCustomMergeFieldWithDays(selectedMergeField)
    ? Number(days) >= 1
    : true;
};
